import { render, staticRenderFns } from "./ObjectSummary.vue?vue&type=template&id=92e0f8a4&"
import script from "./ObjectSummary.vue?vue&type=script&lang=js&"
export * from "./ObjectSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports